import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from '../comum/orgao.model';
import { Usuario } from '../comum/usuario.model';
import { Imovel } from './imovel.model';
import { DepreciacaoImovelItem } from './depreciacao-imovel-item.model';

export class DepreciacaoImovel extends BaseResourceModel {
  constructor(
    public id?: number,
    public mes?: number,
    public ano?: number,
    public pendente?: boolean,
    public usuario?: Usuario,
    public itens?: DepreciacaoImovelItem[],
    public orgao?: Orgao,
    public filtros?: {
      imovel?: Imovel;
      placaInicial?: number;
      placaFinal?: number;
    },
  ) {
    super();
  }

  static converteJson(json: any): DepreciacaoImovel {
    return Object.assign(new DepreciacaoImovel(), json);
  }
}
